import { render } from "./GrantDetails.vue?vue&type=template&id=54cbe27c"
import script from "./GrantDetails.vue?vue&type=script&lang=js"
export * from "./GrantDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QIcon,QTooltip,QToggle,QBtn,QLinearProgress,QSeparator,QTable,QDialog,QCard,QCardSection,QCardActions});
